module.exports = __webpack_public_path__ + "static/media/trash.6fe8b02b.svg";